enum AnalyticsDatastoreType {
  MIXPANEL_BUSINESS = "MIXPANEL_BUSINESS",
  MIXPANEL_INTERNAL = "MIXPANEL_INTERNAL"
}

export default AnalyticsDatastoreType;
